import React from 'react';
import { observer } from 'mobx-react';
import MarkdownContent from './MarkdownContent';
import theme from '../theme';
import {
  Card, CardHeader, CardTitle, WebsiteLink, TwoColumn, SubCard, SubCardTitle, EmptyState,
} from './CompanyPage.styles';

const CompetitorsView = observer(({ competitors }) => {
  if (!competitors || competitors.length === 0) {
    return <EmptyState>No competitors have been added yet.</EmptyState>;
  }

  return (
    <>
      {competitors.map((comp, i) => (
        <Card key={i}>
          <CardHeader>
            <CardTitle>{comp.companyName || `Competitor #${i + 1}`}</CardTitle>
            {comp.website && (
              <WebsiteLink href={comp.website.startsWith('http') ? comp.website : `https://${comp.website}`} target="_blank" rel="noopener noreferrer">
                {comp.website}
              </WebsiteLink>
            )}
          </CardHeader>
          <TwoColumn>
            <SubCard $accent={theme.colors.success}>
              <SubCardTitle $color={theme.colors.success}>Strengths</SubCardTitle>
              <MarkdownContent markdown={comp.strengths} />
            </SubCard>
            <SubCard $accent={theme.colors.danger}>
              <SubCardTitle $color={theme.colors.danger}>Weaknesses</SubCardTitle>
              <MarkdownContent markdown={comp.weaknesses} />
            </SubCard>
          </TwoColumn>
        </Card>
      ))}
    </>
  );
});

export default CompetitorsView;
